import React, { useEffect, useRef } from 'react';
import './MessageModal.css';

interface MessageModalProps {
  isOpen: boolean;
  message: string;
  messageType: 'success' | 'error' | 'info' | 'warning' | 'aviso';
  onClose: () => void;
}

const MessageModal: React.FC<MessageModalProps> = ({ isOpen, message, messageType, onClose }) => {
  const acceptButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.shiftKey) {
        e.preventDefault();
        e.stopPropagation();

        // Trigger click on the "Accept" button
        if (acceptButtonRef.current) {
          acceptButtonRef.current.click();
        }
      }
    };

    // Add event listener specifically for this component's phase
    window.addEventListener('keydown', handleKeyPress, true);

    return () => {
      window.removeEventListener('keydown', handleKeyPress, true);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const getIcon = () => {
    switch (messageType) {
      case 'success':
        return <i className="fas fa-check-circle" style={{ color: '#28a745' }}></i>;
      case 'error':
        return <i className="fas fa-times-circle" style={{ color: '#dc3545' }}></i>;
      case 'warning':
        return <i className="fas fa-exclamation-triangle" style={{ color: '#ffc107' }}></i>;
      case 'aviso':
        return <i className="fas fa-exclamation-triangle" style={{ color: '#ffc107' }}></i>;
      case 'info':
        return <i className="fas fa-info-circle" style={{ color: '#17a2b8' }}></i>;
      default:
        return null;
    }
  };

  return (
    <div className="modal-message-overlay">
      <div className={`modal-message-container ${messageType}`}>
        <h3 className="modal-title">
          {getIcon()} {messageType.toUpperCase()}
        </h3>
        <p className="modal-message">{message}</p>
        <div className="modal-message-button-container">
          <button
            onClick={onClose}
            className="modal-message-btn"
            ref={acceptButtonRef}
          >
            <i className="fas fa-check-circle"></i> Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
